import { render } from "./messagesView.vue?vue&type=template&id=0238d5c6"
import script from "./messagesView.vue?vue&type=script&lang=js"
export * from "./messagesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__